import React from 'react'

const AuditRemove = () => {
  return <>{''}</>
}

export default AuditRemove
